<script lang="ts" setup>
import type { HTMLAttributes } from "vue";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();
</script>

<template>
  <nav id="app-breadcrumb" aria-label="breadcrumb" data-slot="breadcrumb" :class="props.class" class="px-6 py-3">
    <slot />
  </nav>
</template>
